/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'file-lock-fill': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M7 6a1 1 0 012 0v1H7zM6 8.3c0-.042.02-.107.105-.175A.64.64 0 016.5 8h3a.64.64 0 01.395.125c.085.068.105.133.105.175v2.4c0 .042-.02.107-.105.175A.64.64 0 019.5 11h-3a.64.64 0 01-.395-.125C6.02 10.807 6 10.742 6 10.7z"/><path pid="1" d="M12 0H4a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V2a2 2 0 00-2-2m-2 6v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V8.3c0-.627.46-1.058 1-1.224V6a2 2 0 114 0"/>',
    },
});
